<template>
  <Revisions :revisions="implant.revisions" :addOperation="implant._id" @addAppointment="$emit('openAppointment', $event)" :codes="implant.codes" :implant="implant" />
    
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Tipologia intervento"
        v-model="implant.first_operation"
        :options="['Nuova installazione', 'Ristrutturazione', 'Sostituzione del generatore', 'Compilazione libretto impianto esistente']"
      />
    </div>

    <div class="column is-12-mobile is-3-tablet is-2-desktop">
      <div class="field">
        <label class="label">Data intervento</label>
        <div class="control">
          <input class="input" type="date" placeholder="Data intervento" v-model="implant.first_operation_date" />
        </div>
      </div>
    </div>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
          name="Proprietario"
          v-model="implant.client"
          :options="clients"
          :loading="!clients.length"
          :disabled="!clients.length"
          id="_id"
          track-by="_id"
          :custom-label="$clientName"
          :allowEmpty="false"
      >
        <a class="button is-success" href="javascript:void(0)" @click="$emit('openNewClient')"><font-awesome-icon icon="plus" class="m-0" /></a>
        <a class="button is-warning" :href="implant.client ? '/clienti/'+implant.client._id : 'javascript:void(0)'"><font-awesome-icon icon="user" class="m-0" /></a>
      </InputSelect>

      <ClientInfo :client="implant.client" :showAddress="true" />
    </div>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Occupante"
        v-model="implant.occupant"
        :options="clients"
        :loading="!clients.length"
        :disabled="!clients.length"
        id="_id"
        track-by="_id"
        :custom-label="$clientName"
        @select="changeOccupant"
        @remove="removeOccupant"
      >
        <a class="button is-success" href="javascript:void(0)" @click="$emit('openNewOccupant')"><font-awesome-icon icon="plus" class="m-0" /></a>
        <a class="button is-warning" :href="implant.occupant ? '/clienti/'+implant.occupant._id : 'javascript:void(0)'"><font-awesome-icon icon="user" class="m-0" /></a>
      </InputSelect>

      <ClientInfo :client="implant.occupant" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Luogo impianto"
        v-model="implant.place_occupant"
        :options="places_occupant"
        :loading="!clients.length"
        :disabled="implant._id != null || !clients.length || !implant.occupant"
        id="_id"
        track-by="_id"
        :custom-label="$placeName"
      >
        <button class="button is-success" @click="$emit('openNewPlace')" title="Nuovo luogo" type="button" :disabled="!implant.client && !implant.occupant"><font-awesome-icon icon="plus" class="m-0" /></button>
        <button v-if="implant._id" class="button is-primary" @click="$emit('editPlace')" title="Modifica luogo" type="button"><font-awesome-icon icon="pen" class="m-0" /></button>
        <a class="button is-warning" :href="implant.place_occupant ? '/luoghi/'+implant.place_occupant._id : 'javascript:void(0)'"><font-awesome-icon icon="building" class="m-0" /></a>
      </InputSelect>
    </div>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <div class="field">
        <label class="label">Codici</label>
        <div class="control is-flex is-justify-content-space-between">
          <div class="field is-grouped is-grouped-multiline" v-if="implant.codes?.length">
            <div class="control" v-for="(code, index) in implant.codes" :key="index">
              <div class="tags has-addons are-medium">
                <span class="tag is-primary">{{ code }}</span>
                <a class="tag is-delete" @click="() => implant.codes.splice(index, 1)"></a>
              </div>
            </div>
          </div>
          <div v-if="!implant.codes?.length" class="has-text-left">
            <i>Nessuno</i>
          </div>

          <button class="button is-success is-small" @click="this.openModalNewCode = true" title="Aggiungi codice" type="button"><font-awesome-icon icon="plus" class="m-0" /></button>
        </div>
      </div>
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Pod" v-model="implant.pod" />
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Pdr" v-model="implant.pdr" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Targa" v-model="implant.plate" />
    </div>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <div class="field">
        <label class="label">Destinazione impianti termici</label>
        <div class="control is-flex">
          <table class="table is-fullwidth">
            <tbody>
              <tr v-for="(code, index) in implant.codes" :key="index">
                <td><span class="tag is-primary is-medium">{{ code }}</span></td>
                <td>
                  <div class="tags has-addons" v-if="isPowerHotAcs(code)">
                    <span class="tag is-dark">Produzione di acs</span>
                    <span class="tag is-info">{{ calcPowerHot[code] }} (kW)</span>
                  </div>
                  <div class="tags has-addons" v-if="isPowerHotRisc(code)">
                    <span class="tag is-dark">Climatizzazione invernale</span>
                    <span class="tag is-info">{{ calcPowerHot[code] }} (kW)</span>
                  </div>
                  <div class="tags has-addons" v-if="isPowerCool(code)">
                    <span class="tag is-dark">Climatizzazione estiva</span>
                    <span class="tag is-info">{{ calcPowerCool[code] }} (kW)</span>
                  </div>
                </td>
              </tr>
              <tr v-if="calcPowerHot['_none'] || calcPowerCool['_none']">
                <td><span class="tag is-primary is-medium"><i>Nessuno</i></span></td>
                <td>
                  <div class="tags has-addons" v-if="isPowerHotAcs('_none')">
                    <span class="tag is-dark">Produzione di acs</span>
                    <span class="tag is-info">{{ calcPowerHot['_none'] }} (kW)</span>
                  </div>
                  <div class="tags has-addons" v-if="isPowerHotRisc('_none')">
                    <span class="tag is-dark">Climatizzazione invernale</span>
                    <span class="tag is-info">{{ calcPowerHot['_none'] }} (kW)</span>
                  </div>
                  <div class="tags has-addons" v-if="isPowerCool('_none')">
                    <span class="tag is-dark">Climatizzazione estiva</span>
                    <span class="tag is-info">{{ calcPowerCool['_none'] }} (kW)</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <div class="field">
        <label class="label">Tipologia fluido vettore</label>
        <div class="control is-flex">
          <div class="tags">
            <span class="tag is-primary" v-for="(fluid) in calcFluid">{{ fluid }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <div class="field">
        <label class="label">Tipologia dei generatori</label>
        <div class="control is-flex">
          <div class="tags">
            <span class="tag is-primary" v-for="(type) in calcTypes">{{ type }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <div class="field">
        <label class="label">Abbonamenti</label>
        <div class="control is-flex">
          <div class="box" style="width: 100%;">
            <div class="level">
              <div class="level-left"></div>
              <div class="level-right">
                <div class="buttons">
                  <button type="button" class="button is-small is-primary" @click="openModalSubscription = true" :disabled="!implant._id || !isSubscriptionCityEnabled">Nuovo abbonamento</button>
                </div>
              </div>
            </div>

            <div class="mt-2" v-if="implant._id && !isSubscriptionCityEnabled">
              <small class="has-text-danger">Città del luogo non abilitata per nuovi abbonamenti</small>
            </div>

            <div class="mt-3">
              <table class="table is-fullwidth is-striped" v-if="implant.subscriptions && implant.subscriptions.length">
                <thead>
                  <tr>
                    <th>Inizio</th>
                    <th>Fine</th>
                    <th>Attivo</th>
                    <th>Note</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="s in subscriptionsSorted" :key="getSubscriptionKey(s)">
                    <td>{{ new Date(s.start).toDisplay() }}</td>
                    <td>{{ new Date(s.end).toDisplay() }}</td>
                    <td>
                      <span :class="['tag', 'is-small', isSubscriptionActive(s) ? 'is-success' : 'is-danger']">
                        {{ isSubscriptionActive(s) ? 'Valido' : 'Scaduto' }}
                      </span>
                    </td>
                    <td>{{ s.note }}</td>
                    <td class="is-narrow">
                      <div class="buttons">
                        <button type="button" class="button is-small is-warning" @click="openEditSubscriptionModal(s)">Modifica date</button>
                        <button type="button" class="button is-small is-danger" @click="deleteSubscription(s)">Elimina</button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-else>
                <small class="has-text-grey">Nessun abbonamento presente</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputTextarea name="Note" v-model="implant.notes" />
    </div>

    <Modal :title="'Aggiungi codice'" :openModal="openModalNewCode" @close="openModalNewCode = false" @success="addCode()">
      <InputText name="Codice" v-model="newCode" />
    </Modal>

    <Modal :title="'Nuovo abbonamento'" :openModal="openModalSubscription" @close="openModalSubscription = false" @success="createSubscription" :loading="savingSubscriptions" :allowOverflow="true">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="field">
            <label class="label">Data inizio</label>
            <InputDate v-model="subscriptionForm.start" placeholder="Data inizio" />
          </div>
        </div>
        <div class="column is-12">
          <InputText name="Note" v-model="subscriptionForm.note" />
        </div>
      </div>
    </Modal>

    <Modal :title="'Modifica date abbonamento'" :openModal="openModalEditSubscription" @close="openModalEditSubscription = false" @success="saveEditedSubscription" :loading="savingSubscriptions" :allowOverflow="true">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="field">
            <label class="label">Data inizio</label>
            <InputDate v-model="subscriptionEditForm.start" placeholder="Data inizio" />
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">Data fine</label>
            <InputDate v-model="subscriptionEditForm.end" placeholder="Data fine" />
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import utils from '../../utils.js'

export default {
  props: {
    implant: Object,
    clients: Array
  },
  emits: ['update:implant', 'openNewOccupant', 'openNewClient', 'editPlace', 'openNewPlace', 'openAppointment'],
  data() {
    return {
      places_occupant: [],

      openModalNewCode: false,
      newCode: ''
      ,
      // subscriptions
      openModalSubscription: false,
      subscriptionForm: {
        start: new Date().toISOString().slice(0,10),
        note: ''
      },
      openModalEditSubscription: false,
      subscriptionEditForm: {
        start: '',
        end: ''
      },
      selectedSubscription: null,
      subscriptionKeys: new WeakMap(),
      subscriptionKeyCounter: 0,
      savingSubscriptions: false
    }
  },

  computed: {
    enabledSubscriptionCityNames() {
      return (this.$store.state.subscription_enabled_cities || [])
        .map(row => this.normalizeSubscriptionCity(row?.name))
        .filter(Boolean)
    },

    implantPlaceCity() {
      return this.normalizeSubscriptionCity(this.implant?.place_occupant?.city || '')
    },

    isSubscriptionCityEnabled() {
      const city = this.implantPlaceCity
      if (!city) {
        return false
      }
      return this.enabledSubscriptionCityNames.includes(city)
    },

    subscriptionsSorted() {
      if (!this.implant || !this.implant.subscriptions) return []
      return [...this.implant.subscriptions].sort((a, b) => new Date(b.end) - new Date(a.end))
    },

    generators() {
      return utils.getGenerators(this.implant)
    },

    calcFluid() {
      const fluids = []

      for (const generator of this.generators) {
        if (generator.fluid && !fluids.includes(generator.fluid)) {
          fluids.push(generator.fluid)
        }
        if (generator.fluid_user && !fluids.includes(generator.fluid_user)) {
          fluids.push(generator.fluid_user)
        }
        if (generator.fluid_fridge && !fluids.includes(generator.fluid_fridge)) {
          fluids.push(generator.fluid_fridge)
        }
      }

      return fluids
    },

    calcTypes() {
      return utils.calcTypes(this.implant)
    },

    calcPowerHot() {
      let powerByCode = {}

      for (const generator of this.generators) {
        let power = '0'

        if (generator.power_useful) {
          power = generator.power_useful
        } else if (generator.power_total) {
          power = generator.power_total
        } else if (generator.power_nominal_hot) {
          power = generator.power_nominal_hot
        } else if (generator.power) {
          power = generator.power
        }

        power = power.replace(',', '.')
        
        if (generator.code) {
          if (powerByCode[generator.code]) {
            powerByCode[generator.code] += parseFloat(power)
          } else {
            powerByCode[generator.code] = parseFloat(power)
          }
        } else {
          if (powerByCode['_none']) {
            powerByCode['_none'] += parseFloat(power)
          } else {
            powerByCode['_none'] = parseFloat(power)
          }
        }
      }

      return powerByCode
    },

    calcPowerCool() {
      let powerByCode = {}

      for (const generator of this.generators) {
        let power = '0'

        if (generator.power_nominal_cool) {
          power = generator.power_nominal_cool
        }

        power = power.replace(',', '.')
        
        if (generator.code) {
          if (powerByCode[generator.code]) {
            powerByCode[generator.code] += parseFloat(power)
          } else {
            powerByCode[generator.code] = parseFloat(power)
          }
        } else {
          if (powerByCode['_none']) {
            powerByCode['_none'] += parseFloat(power)
          } else {
            powerByCode['_none'] = parseFloat(power)
          }
        }
      }

      return powerByCode
    }
  },

  methods: {
    normalizeSubscriptionCity(value) {
      if (!value || typeof value !== 'string') {
        return ''
      }

      return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toUpperCase()
    },

    getSubscriptionKey(subscription) {
      if (!subscription || typeof subscription !== 'object') {
        return 'invalid-subscription'
      }

      if (!this.subscriptionKeys.has(subscription)) {
        this.subscriptionKeyCounter += 1
        this.subscriptionKeys.set(subscription, 'subscription-' + this.subscriptionKeyCounter)
      }

      return this.subscriptionKeys.get(subscription)
    },

    findSubscriptionIndex(targetSubscription) {
      if (!Array.isArray(this.implant?.subscriptions)) {
        return -1
      }

      const byReference = this.implant.subscriptions.indexOf(targetSubscription)
      if (byReference !== -1) {
        return byReference
      }

      return this.implant.subscriptions.findIndex(subscription => {
        if (targetSubscription?.createdAt && subscription?.createdAt) {
          return subscription.createdAt === targetSubscription.createdAt
        }

        return (
          subscription?.start === targetSubscription?.start &&
          subscription?.end === targetSubscription?.end &&
          (subscription?.note || '') === (targetSubscription?.note || '')
        )
      })
    },

    openEditSubscriptionModal(subscription) {
      this.selectedSubscription = subscription
      this.subscriptionEditForm.start = subscription?.start || ''
      this.subscriptionEditForm.end = subscription?.end || ''
      this.openModalEditSubscription = true
    },

    async saveEditedSubscription() {
      if (!this.implant._id || !this.selectedSubscription) return

      if (!this.subscriptionEditForm.start || !this.subscriptionEditForm.end) {
        alert('Inserisci sia data inizio che data fine')
        return
      }

      const start = new Date(this.subscriptionEditForm.start)
      const end = new Date(this.subscriptionEditForm.end)
      if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
        alert('Date non valide')
        return
      }
      if (end < start) {
        alert('La data fine non puo essere precedente alla data inizio')
        return
      }

      const idx = this.findSubscriptionIndex(this.selectedSubscription)
      if (idx === -1) return

      this.savingSubscriptions = true

      this.implant.subscriptions[idx].start = this.subscriptionEditForm.start
      this.implant.subscriptions[idx].end = this.subscriptionEditForm.end

      try {
        await this.$http.put('/implant/' + this.implant._id, { subscriptions: this.implant.subscriptions })
        this.openModalEditSubscription = false
        this.selectedSubscription = null
      } catch (err) {
        console.error(err)
        alert('Errore aggiornamento abbonamento')
      }

      this.savingSubscriptions = false
    },

    getPlaces(client, type) {
      const self = this
      self.waitPlaces = true

      this.$http.get('/place', { params: {page: 1, size: -1, client: client._id} })
      .then(function (response) {
        if (response && response.data) {
          const records = response.data.records
          if (type === 'client') {
            self.places = records
          } else if (type === 'occupant') {
            self.places_occupant = records
          }

          if (records.length === 1) {
            if (type === 'client') {
              self.implant.place = records[0]
            } else if (type === 'occupant') {
              self.implant.place_occupant = records[0]
            }
          }
        }
        self.waitPlaces = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    changeOccupant(occupant) {
      if (this.implant._id) {
        return
      }
      this.implant.place_occupant = null

      if (occupant) {
        this.getPlaces(occupant, 'occupant')
      }
    },

    removeOccupant() {
      this.implant.place_occupant = null
    },

    addCode() {
      this.openModalNewCode = false
      if (!this.implant.codes) {
        this.implant.codes = []
      }
      this.implant.codes.push(this.newCode)
      this.newCode = ''
    },

    isPowerHotAcs(code) {
      for (const generator of this.generators) {
        if (
          (generator.code === code || (!generator.code && code === '_none')) &&
          generator.usage?.includes('ACS')
        ) {
          return true
        }
      }

      return false
    },

    isPowerHotRisc(code) {
      for (const generator of this.generators) {
        if (
          (generator.code === code || (!generator.code && code === '_none')) &&
          generator.usage?.includes('Risc')
        ) {
          return true
        }
      }

      return false
    },

    isPowerCool(code) {
      for (const generator of this.generators) {
        if (
          (generator.code === code || (!generator.code && code === '_none')) &&
          generator.usage?.includes('Raff')
        ) {
          return true
        }
      }

      return false
    },

    async createSubscription() {
      if (!this.implant._id) return
      if (!this.isSubscriptionCityEnabled) {
        alert('Città del luogo non abilitata per nuovi abbonamenti')
        return
      }

      this.savingSubscriptions = true

      const sd = new Date(this.subscriptionForm.start)
      const ed = new Date(sd)
      ed.setFullYear(ed.getFullYear() + 1)
      ed.setDate(ed.getDate() - 1)

      const startStr = sd.toISOString().slice(0,10)
      const endStr = ed.toISOString().slice(0,10)

      const subscription = {
        start: startStr,
        end: endStr,
        createdAt: new Date().toISOString(),
        createdBy: null,
        note: this.subscriptionForm.note || ''
      }

      if (!this.implant.subscriptions) this.implant.subscriptions = []
      this.implant.subscriptions.push(subscription)

      try {
        await this.$http.put('/implant/' + this.implant._id, { subscriptions: this.implant.subscriptions })
        this.openModalSubscription = false
        this.subscriptionForm = { start: new Date().toISOString().slice(0,10), note: '' }
      } catch (err) {
        console.error(err)
        alert('Errore salvataggio abbonamento')
      }

      this.savingSubscriptions = false
    },

    async deleteSubscription(subscription) {
      if (!this.implant._id) return

      if (!confirm('Eliminare questo abbonamento?')) return

      const idx = this.findSubscriptionIndex(subscription)
      if (idx === -1) return

      this.implant.subscriptions.splice(idx, 1)
      try {
        await this.$http.put('/implant/' + this.implant._id, { subscriptions: this.implant.subscriptions })
      } catch (err) {
        console.error(err)
        alert('Errore eliminazione abbonamento')
      }
    }

    ,
    isSubscriptionActive(s) {
      if (!s || !s.end) return false
      try {
        const today = new Date()
        const ed = new Date(s.end)
        today.setHours(0,0,0,0)
        ed.setHours(0,0,0,0)
        return ed >= today
      } catch (e) {
        return false
      }
    }
  }
}
</script>